var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"button",class:_vm.additionalClasses,attrs:{"target":"_blank","href":_vm.link},on:{"mousedown":function($event){return _vm.$modal.show('productQrModal')},"click":function($event){$event.preventDefault();return _vm.$modal.show('productQrModal')}}},[_vm._v(_vm._s(_vm.buttonText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }